import { render, staticRenderFns } from "./ResponsiveGrid.vue?vue&type=template&id=36936d6f"
import script from "./ResponsiveGrid.vue?vue&type=script&lang=js"
export * from "./ResponsiveGrid.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveGrid.vue?vue&type=style&index=0&id=36936d6f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports